<template>
<div class="row">
  
  <div class="col-12 mb-4" v-if="(consulta && consulta.tipo_status && consulta.tipo_status.id == 66)">
      <ed-alert
        type="success"
        :description="'Essa consulta foi LIBERADA em '+toDate(consulta.updated_at)"
        title="Atenção"
      />

      <div class="col-12  mt-4 text-center">
        <ed-button
          icon="fa fa-print"
          type="success"
          title="Imprimir"
          value="Imprimir Ficha Clínica"
          @click="imprimir"
        />
      </div>
  </div>

  <div class="col-12 mb-4" v-else-if="(consulta && consulta.tipo_status && (consulta.tipo_status.id == 57 || consulta.tipo_status.id == 58))">
      <ed-alert
        type="error"
        :description="'Essa consulta foi '+consulta.tipo_status.descricao+' em '+toDate(consulta.updated_at)+'. Nenhuma alteração pode ser efetuada.'"
        title="Atenção"
      />

      <div class="col-12 mt-4 text-center">
        <ed-button
          icon="fa fa-arrow-left"
          type="primary"
          value="Voltar"
          @click="toRoute({name:'credenciada.consulta'})"
        />
      </div>
  </div>
  
  <div class="col-12 mb-2" v-loading="config.loading.content" v-else>

    <ed-form :data="formData" :response="response" :config="config" :itens="formItems">
      <div slot="form-footer" >
      </div>
		</ed-form>

    <div class="col-12 text-center mt-3 mb-2">
      <el-checkbox 
        v-model="formData.empty"
        :checked="formData.empty == 1"
      >
        <span style="color:red">Gostaria de preencher tudo a mão</span>
      </el-checkbox>
    </div>

    <div class="col-12 text-center">
      <ed-button
        icon="fa fa-print"
        type="success"
        title="Clique Aqui para Imprimir"
        value="Salvar Alterações e Imprimir Ficha Clínica"
        @click="imprimir"
      />
    </div>

  </div>
</div>
</template>

<script>
import Rest from 'common/rest'
import EdAlert from 'common/alert'
import EdForm from 'common/form'
import EdButton from 'common/button'
import FormItems from '../_form/consulta-config-femo'

export default {
    name: 'aso',
    components:{EdAlert,EdForm,EdButton},
    mixins:[Rest],
    props:{
      consulta:{
        type: Object,
        default: {}
      }
    },
    watch:{
      'consulta.id'(){
        this.getConsulta()
      },
      'consulta.tipo_status.id'(){
      },
      'formData.q14'(){
        this.config.disabled.qd14 = (this.formData.q14 != '133' ? false : true);
      },
      'formData.q116'(){
        this.config.disabled.qd116 = (this.formData.q116 != '133' ? false : true);
      },
      'formData.q14'(){
        this.config.disabled.qd14 = (this.formData.q14 != '133' ? false : true);
      },
      'formData.q11024'(){
        this.config.disabled.qd11024 = (this.formData.q11024 != '133' ? false : true);
      },
      'formData.q14096'(){
        this.config.disabled.qd14096 = (this.formData.q14096 != '133' ? false : true);
      },
      'formData.q116384'(){
        this.config.disabled.qd116384 = (this.formData.q116384 != '133' ? false : true);
      },
      'formData.q132768'(){
        this.config.disabled.qd132768 = (this.formData.q132768 != '133' ? false : true);
      },
      'formData.q165536'(){
        this.config.disabled.qd165536 = (this.formData.q165536 != '133' ? false : true);
      },
      'formData.q12048'(){
        this.config.disabled.qd12048 = (this.formData.q12048 != '133' ? false : true);
      },
      'formData.q18192'(){
        this.config.disabled.qd18192 = (this.formData.q18192 != '133' ? false : true);
      },
      'formData.q22'(){
        this.config.disabled.qd22 = (this.formData.q22 != '133' ? false : true);
      },
    },
    data () {
      return{
        config:{
          tipo:[122,131,134,139,144,152,158,164,167,171,180],
          loading:{
            content:false,
            save:false
          },
          disabled:{
            qd14: true,
            qd116: true,
            qd11024: true,
            qd14096: true,
            qd116384: true,
            qd132768: true,
            qd165536: true,
            qd12048:true,
            qd18192:true,
            qd22:true,
          }
        },
        response:{

        },
        formData:{
          id:0,
          empty:0,
          grau_estudo:null,
          peso:null,
          altura:null,
          pa1:null,
          pa2:null,
          q14:'133',
          qd14:null,
          q18:'0',
          q116:'133',
          qd116:null,
          q132:'132',
          q164:'133',
          q1128:'133',
          q1256:'133',
          q1512:'133',
          q11024:'133',
          qd11024:null,
          q12048:'133',
          qd12048:null,
          q14096:'133',
          qd14096:null,
          q18192:'133',
          q116384:'133',
          qd116384:null,
          q132768:'133',
          qd132768:null,
          q165536:'133',
          qd165536:null,
          q22:'133',
          qd22:null,

          q34:[],
          q44:[],
          q54:[],
          q64:[],
          q74:[],
          q84:[],
          q94:[],
          conclusao:null,
          observacoes:null,
        },
        formItems:[]
      }
    },

    created(){
    },
    mounted(){
      this.formItems = FormItems;
      this.getConsulta();
    },

    methods: {

      imprimir(){
        
        this.config.loading.save = true;

        this.post('consulta/femo/'+this.consulta.id_con+'/editar',this.formData).then((result) =>{

          result = result[0];

          this.config.loading.save = false;

          if(result.status == 200){
            this.open('consulta/femo/'+this.toMd5(this.consulta.id_con)+'/gerar',{empty:(this.formData.empty ? 1 : 0)});
          }
        });
      },

      getConsulta(){

        if(!this.consulta || !this.consulta.id)return;

        this.config.loading.content = true;
        this.tabSelected = 'tab-aso';
        this.response = {};

        this.get("consulta/femo/"+this.consulta.id_con).then(result =>{

          result = result[0];

          this.response = result;

          this.config.loading.content = false;

          if(result.status == 200){

            var data = result.data, resposta = null;
            
            if(data){
              resposta = data.resposta;

              this.formData.id = data.id;
              this.formData.pa1 = data.pa1;
              this.formData.pa2 = data.pa2;
              this.formData.peso = data.peso;
              this.formData.altura = data.altura;
              this.formData.observacoes = data.observacoes;
              this.formData.grau_estudo = (data.tipo_grau_estudo ? data.tipo_grau_estudo.valor.toString() : null);
              this.formData.conclusao = data.conclusao;

              for(var q1 in resposta){

                if(resposta[q1]){
                  for(var q2 in resposta[q1]){
                    
                    var 
                      form_value = 'q'+q1+q2, 
                      form_desc = 'qd'+q1+q2,
                      valor = (resposta[q1][q2] && resposta[q1][q2].valor ? resposta[q1][q2].valor : 0),
                      descricao = (resposta[q1][q2] && resposta[q1][q2].valor ? resposta[q1][q2].descricao : null);
                      switch (q1) {
                        case '1':
                          
                          this.formData[form_value] = (q2 == 8 ? '0' : '133');
                          this.formData[form_desc] = null;

                          if(valor == 1){

                            //BEBIDA
                            if(q2 == 8){
                              this.formData[form_value] = (parseInt(descricao)+8).toString();
                            }
                            else{
                              this.formData[form_value] = '132';
                              this.formData[form_desc] = descricao;
                            }
                            
                          }
                        break;

                        default:
                            if(valor == 1){
                              this.formData['q'+q1+'4'].push(q2);
                            }
                        break;
                      }
                      
                  }
                }
                
              }
            }
          }
        });
      },
    }
}
</script>


// WEBPACK FOOTER //
// femo.vue?5dad0c02